import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../services/partner.service';
import{UserServices} from '../services/userservices.service'
import { ApplicationService } from '../services/application.service'
@Component({
  selector: 'app-diagnostics',
  templateUrl: './diagnostics.component.html',
  styleUrls: ['./diagnostics.component.css']
})
export class DiagnosticsComponent implements OnInit {

  orderItemList:any[];
  isLoginByAdmin: boolean = false;
  partnerTypeId:string=''
   //orderItemList : Observable<any>;
  statusMessage: string = "Loading data please wait...";
  constructor(private _partnerService:PartnerService,private userServices:UserServices,private _applicationService: ApplicationService) {
    this.isLoginByAdmin = _applicationService.loginUserDetails.isAdmin
    this.partnerTypeId = _applicationService.loginUserDetails.partnertypeId
   }

  ngOnInit() {
    this.getDiagnosticsOrder();
  }

  getDiagnosticsOrder() {   
    this._partnerService.getDiagnosticsOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order;           
          }         
        console.log(this.orderItemList)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }
  viewItems(data) {
    debugger
    if (data.isViewRecord) {
        data.isViewRecord = false;
    }
    else {
        data.isViewRecord = true;
    }
}

userVerfication(userDetails) {
  this.userServices.setPatientData(userDetails)
}

updateOrderDeliveryStatus(order) {
  debugger;
  let confimationMessage = "Are you sure this order is deliver to " + order.patientName;
  if (confirm(confimationMessage)) {    
    var loginUser = JSON.parse(localStorage.getItem('currentUser')); 
    order.token =loginUser.token;
    this._partnerService.updateOrderDeliveryStatus(order).subscribe(
     
      data => {
        if (data.returnCode == 0) {
          alert("Record updated sucessfully")
         

        }
        else {
          if (data.returnCode == 2) {


          }
        }
       
      },
      error => {
        // this.alertService.error(error);
        // this.loading = false;         
        alert(error)
        console.log(error)
      });
  }


}



}
